import React from 'react';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const ContactPage = () => {
  return (
    <>
        <Contact/>
        <Footer/>
    </>
  )
}

export default ContactPage;